import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { triggerSilentOpenEdxLogin } from '@utils/edxSession';
import { LoginRequestPayload } from '@store/actions/authActions';
import { PayloadAction } from "@reduxjs/toolkit";
import { loginFailure, loginRequest, loginSuccess, sessionConflictDetected } from "@store/reducers/authReducer";

const API_URL = process.env.REACT_APP_API_URL;

function* loginSaga(action: PayloadAction<LoginRequestPayload & { force_login?: boolean }>): Generator<any, void, any> {
    try {
        const response: any = yield call(axios.post, API_URL + '/api-token-auth/', action.payload);
        const data = response.data;

        // Another session is active — surface the conflict modal
        if (data.session_conflict) {
            // Only carry the username for retry display — never include password in Redux state
            yield put(sessionConflictDetected({
                access_token: '',
                user_id: 0,
                email: '',
                role: '',
                avatar_url: null,
                full_name: null,
                username: null,
                // Carry the original credentials for the force-login retry
                ...(action.payload as any),
            }));
            return;
        }

        const { access_token, user_id, email, role, avatar_url, full_name, username, k12_username, session_key, rbac } = data;
        yield put(loginSuccess({
            access_token,
            user_id,
            email,
            role,
            avatar_url,
            full_name,
            username: username ?? null,
            k12_username: k12_username ?? null,
            session_key,
            rbac: rbac ?? null,
        }));

        // ponytail: fire-and-forget, không yield để không block saga nếu OpenEdX chậm
        triggerSilentOpenEdxLogin(access_token);
    } catch (e: any) {
        let errorMessage = 'Đăng nhập không thành công. Hãy liên hệ với quản trị viên để được hỗ trợ.';
        if (e?.response?.data?.non_field_errors) {
            if (e.response.data.non_field_errors.includes("Unable to log in with provided credentials.")) {
                errorMessage = "Sai thông tin đăng nhập";
            }
        }
        yield put(loginFailure({ error: errorMessage }));
    }
}

function* authSaga() {
    yield takeLatest(loginRequest.type, loginSaga);
}

export default authSaga;
